import produce from 'immer';
import {
	COMA_FILTER_CHANGED,
	COMA_RESET,
	COMA_SORT_CHANGED
} from './content-manager.actions';
import {
	CoMaFilterState,
	CoMaSortState,
	ContentManagerAction,
	IContentManagerState
} from './content-manager.types';

const coMaInitialState: IContentManagerState = {
	filter: {
		property: '',
		value: ''
	},
	sort: {
		property: '',
		order: 'asc'
	}
};

export function ContentManagerReducer(
	state: IContentManagerState = coMaInitialState,
	action: ContentManagerAction
): IContentManagerState {
	switch (action.type) {
		case COMA_FILTER_CHANGED:
			return setFilter(state, action.payload as CoMaFilterState);
		case COMA_SORT_CHANGED:
			return setSort(state, action.payload as CoMaSortState);
		case COMA_RESET:
			return coMaInitialState;
		default:
			return state;
	}
}

function setFilter(
	currentState: IContentManagerState,
	filter: CoMaFilterState
): IContentManagerState {
	return produce(currentState, (draftState: IContentManagerState) => {
		draftState.filter = filter;
	});
}

function setSort(
	currentState: IContentManagerState,
	sort: CoMaSortState
): IContentManagerState {
	return produce(currentState, (draftState: IContentManagerState) => {
		draftState.sort = sort;
	});
}
